var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"top gap-2"},[_c('div',{staticClass:"welcome_text"},[_c('p',[_vm._v(" Welcome"),_c('br'),_c('span',[_vm._v(" "+_vm._s(_vm.groupInfo.group_name)+" ")]),_c('br'),_vm._v(" Your Employer / Group is "),_c('strong',[_vm._v(_vm._s(_vm.groupInfo.group_type))])])])])
}
var staticRenderFns = []

export { render, staticRenderFns }